import { FieldModel, ProgramBenchmarkName, ProgramTask, TaskDataTraitStatus } from '@cibo/core'
import { CashCropCellDisplay } from '@cibo/landmanager'
import { TraitCellContainer } from './TraitCellContainer'

interface CashCropCellProps {
  value: any
  task: ProgramTask<{ benchmarkName: ProgramBenchmarkName; traits: TaskDataTraitStatus[] }>
  year: number
  selectedField?: FieldModel
  onSaveSuccess?: () => void
}

export const CashCropCell = ({
  value,
  task,
  year,
  selectedField,
  onSaveSuccess,
}: CashCropCellProps) => {
  return (
    <TraitCellContainer
      value={value}
      task={task}
      selectedField={selectedField}
      year={year}
      traitId="cashCrop"
      onSaveSuccess={onSaveSuccess}
    >
      <CashCropCellDisplay value={value} />
    </TraitCellContainer>
  )
}
